import { ActionTypes } from './constants';
import { ModalOptions } from '.';
import { Dispatch } from 'redux';

export const showModal = (options: ModalOptions) => (dispatch: Dispatch) => {
    dispatch({
        type: ActionTypes.MODAL_SHOW,
        options
    });
};

export const hideModal = (options: ModalOptions) => (dispatch: Dispatch) => {
    dispatch({
        type: ActionTypes.MODAL_HIDE,
        options
    });
};
